module.exports = __webpack_public_path__ + "static/media/Base-Logo.1c0289e9.png";